"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _Asset = _interopRequireDefault(require("../../../../Asset"));

var _Clips = _interopRequireDefault(require("../../Clips"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var SortableClip = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var props = _ref.value;
  return /*#__PURE__*/_react.default.createElement(_Asset.default, props);
});

var Clip = /*#__PURE__*/function (_Component) {
  _inherits(Clip, _Component);

  var _super = _createSuper(Clip);

  function Clip() {
    _classCallCheck(this, Clip);

    return _super.apply(this, arguments);
  }

  _createClass(Clip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clip = _this$props.clip,
          index = _this$props.index,
          onSelectAsset = _this$props.onSelectAsset,
          selectedAssets = _this$props.selectedAssets,
          onUpdateLabelsForAsset = _this$props.onUpdateLabelsForAsset,
          assignedLabels = _this$props.assignedLabels,
          labels = _this$props.labels,
          onRemoveAssets = _this$props.onRemoveAssets,
          viewAssetDetails = _this$props.viewAssetDetails,
          canUpdateVideo = _this$props.canUpdateVideo,
          hasArchiveAssetsPermission = _this$props.hasArchiveAssetsPermission,
          hasDeleteAssetsPermission = _this$props.hasDeleteAssetsPermission,
          onArchiveAsset = _this$props.onArchiveAsset,
          onDeleteAsset = _this$props.onDeleteAsset,
          hasCommentPermission = _this$props.hasCommentPermission,
          onAddComments = _this$props.onAddComments,
          setFileDropIndex = _this$props.setFileDropIndex;
      var assetId = clip.assetId;
      return /*#__PURE__*/_react.default.createElement(SortableClip, {
        key: clip.clipId,
        index: index,
        disabled: !canUpdateVideo,
        value: {
          clipId: clip.clipId,
          onChange: onSelectAsset(assetId),
          assetId: assetId,
          selected: selectedAssets.includes(assetId),
          onUpdateLabelsForAsset: onUpdateLabelsForAsset(assetId),
          selectedLabels: assignedLabels[assetId],
          labels: labels,
          onRemoveAssetFromVideo: onRemoveAssets({
            assetId: assetId
          }),
          onRemoveAssetFromProject: onRemoveAssets({
            assetId: assetId,
            removeFromProject: true
          }),
          viewAssetDetails: viewAssetDetails(assetId),
          canUpdateVideo: canUpdateVideo,
          hasArchiveAssetsPermission: hasArchiveAssetsPermission,
          hasDeleteAssetsPermission: hasDeleteAssetsPermission,
          onArchiveAsset: onArchiveAsset(assetId),
          onDeleteAsset: onDeleteAsset(assetId),
          hasCommentPermission: hasCommentPermission,
          onAddComments: onAddComments(clip.clipId),
          setFileDropIndex: setFileDropIndex,
          clipIndex: index
        }
      });
    }
  }]);

  return Clip;
}(_react.Component);

var _default = Clip;
exports.default = _default;